import { LegalStructureNodeType } from '../../../../services/queries/MaggieLegalStructureQueries';

/**
 * The graph↔register join key.
 *
 * Both the graph (`toStructureGraph`) and the legal register (`useEntityDetail`) key
 * their rows this way so a node's id can be looked up in the register directly. There
 * must be exactly one implementation of this format — if the two ever drift, every
 * register lookup silently misses, which reads as "no entity is a registered legal
 * entity" rather than as the bug it is. The URL carries roots and subjects in the same
 * form, so a link and a picker value are register keys too.
 */
export function nodeKey(nodeType: string, nodeId: number): string {
  return `${nodeType}-${nodeId}`;
}

/**
 * The inverse, for values that arrive from outside — a URL, a select — where nothing
 * guarantees the shape. Only the listed types parse; anything else is undefined, so a
 * caller narrows to the node types its read can actually root at.
 */
export function parseNodeKey<T extends LegalStructureNodeType>(
  raw: string | null | undefined,
  allowed: readonly T[]
): { nodeType: T; nodeId: number } | undefined {
  const match = raw == null ? null : /^([a-z]+)-(\d+)$/.exec(raw);
  if (!match) {
    return undefined;
  }
  const nodeType = allowed.find((type) => type === match[1]);

  return nodeType === undefined ? undefined : { nodeType, nodeId: Number(match[2]) };
}
